module.exports = __webpack_public_path__ + "img/body-elements.6b55c7f7.png";